<template>
  <div>
    <div class="person-box" :class="{ mobile :isMobile}">
      <i class="close iconfont icon-close-o" @click="$emit('update:show',false)"></i>
      <div class="title">
        <div class="name">{{ row.ext.introName }}</div>
        <img class="line" src="@/assets/images/title-line.png">
        <div v-if="row.ext.introLabel" class="label">【{{ row.ext.introLabel }}】</div>
      </div>
      <div class="content" v-html="row.ext.introText"></div>
    </div>
    <div class="mask"></div>
  </div>

</template>

<script>
  export default {
		props: {
			show: {
				type: Boolean,
				default: false
			},
			row: {
				type: Object,
				default: null
			}
		},
  }
</script>

<style scoped>
  .person-box{
    position: fixed;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    background: #fff;
    z-index: 2000;
    padding: 20px;
    border-radius: 4px;
    width: 400px;
  }
  .person-box.mobile{
    width: 70%;
  }
  .close{
    position: absolute;
    right: 0;
    top:0;
    width: 50px;
    height: 50px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1;
  }
  .name{
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  .line{
    display: block;
    margin: 5px auto 20px auto;
    width: 100%;
  }

  .content{
    max-height: 300px;
    min-height: 100px;
    overflow-y: auto;
  }
  .mask{
    position: fixed;
    left:0;
    top:0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 1999;
  }

  .title{
    position: relative;
  }

  .title .label{
    position: absolute;
    color: #f00;
    left:0;
    top:5px;
  }
</style>